module.exports = __webpack_public_path__ + "img/awg-logo-2-10-2020.36984cbd.png";